import { createGlobalStyle } from 'styled-components';

import getHtmlTagSpacing from '../helpers/getHtmlTagSpacing';

const SpacingCSS = createGlobalStyle`
  ${(props) => getHtmlTagSpacing(props.theme)};
`;

export default SpacingCSS;
